import React from 'react';
import styles from './WhyUs.module.css';
import useReveal from './useReveal';

const reasons = [
  'Complete technology and marketing solutions under one roof',
  'Experienced in both software development and digital marketing',
  'Data-driven strategies for measurable, trackable growth',
  'Focus on long-term business partnerships, not one-off projects',
  'Modern technologies and innovative, future-proof approaches',
];

export default function WhyUs() {
  const leftRef = useReveal();
  const rightRef = useReveal();

  return (
    <section className={styles.section} id="why">
      <div className={styles.inner}>
        <div className={`reveal ${styles.left}`} ref={leftRef}>
          <span className="section-label">// why choose us</span>
          <h2 className="section-title">Why <em>404 Stack</em> Wins</h2>
          <p className="section-sub">
            We don't just build websites — we build complete digital growth systems for businesses that want to scale.
          </p>
          <div className={styles.list}>
            {reasons.map((r, i) => (
              <div key={i} className={styles.item}>
                <span className={styles.check}>✓</span>
                <p>{r}</p>
              </div>
            ))}
          </div>
        </div>

        <div className={`reveal ${styles.right}`} ref={rightRef}>
          <div className={styles.codeBlock}>
            <div className={styles.macBar}>● ● ●</div>
            <div className={styles.line}><span className={styles.cp}>class</span> <span className={styles.cc}>FourOhFourStack</span> <span className={styles.cw}>{'{'}</span></div>
            <div className={styles.line} style={{marginLeft:'20px'}}><span className={styles.cp}>constructor</span><span className={styles.cw}>(business) {'{'}</span></div>
            <div className={styles.line} style={{marginLeft:'40px'}}><span className={styles.co}>this</span><span className={styles.cw}>.client = business;</span></div>
            <div className={styles.line} style={{marginLeft:'40px'}}><span className={styles.co}>this</span><span className={styles.cw}>.stack = [</span></div>
            <div className={styles.line} style={{marginLeft:'60px'}}><span className={styles.cg}>'development'</span><span className={styles.cw}>,</span></div>
            <div className={styles.line} style={{marginLeft:'60px'}}><span className={styles.cg}>'marketing'</span><span className={styles.cw}>,</span></div>
            <div className={styles.line} style={{marginLeft:'60px'}}><span className={styles.cg}>'seo'</span><span className={styles.cw}>,</span></div>
            <div className={styles.line} style={{marginLeft:'60px'}}><span className={styles.cg}>'growth'</span></div>
            <div className={styles.line} style={{marginLeft:'40px'}}><span className={styles.cw}>];</span></div>
            <div className={styles.line} style={{marginLeft:'20px'}}><span className={styles.cw}>{'}'}</span></div>
            <div className={styles.line} style={{marginLeft:'20px'}}><span className={styles.cc}>build</span><span className={styles.cw}>() {'{'}</span></div>
            <div className={styles.line} style={{marginLeft:'40px'}}><span className={styles.cp}>return</span> <span className={styles.co}>this</span><span className={styles.cw}>.stack</span></div>
            <div className={styles.line} style={{marginLeft:'60px'}}><span className={styles.cw}>.</span><span className={styles.cc}>map</span><span className={styles.cw}>(s =&gt; </span><span className={styles.cc}>solve</span><span className={styles.cw}>(s))</span></div>
            <div className={styles.line} style={{marginLeft:'60px'}}><span className={styles.cw}>.</span><span className={styles.cc}>reduce</span><span className={styles.cw}>((acc, v) =&gt;</span></div>
            <div className={styles.line} style={{marginLeft:'80px'}}><span className={styles.cw}>acc + </span><span className={styles.cg}>'growth'</span><span className={styles.cw}>, 0);</span></div>
            <div className={styles.line} style={{marginLeft:'20px'}}><span className={styles.cw}>{'}'}</span></div>
            <div className={styles.line}><span className={styles.cw}>{'}'}</span></div>
            <div className={`${styles.line} ${styles.comment}`} style={{marginTop:'12px'}}>// ✓ Status: 200 OK — Your business is now live</div>
          </div>
        </div>
      </div>
    </section>
  );
}
